import styled from 'styled-components';

export const StyledMap = styled.img<{ mapWidth: number; mapHeight: number }>`
  position: relative;
  width: ${({ mapWidth }) => mapWidth + 'rem'};
  height: ${({ mapHeight }) => mapHeight + 'rem'};
  border-radius: 5px;
`;
